<app-dialogue-box [isDialogOpen]="isReportStatusDialogOpen" [title]="dialogTexts.REPORT_STATUS.TITLE"
    [message]="reportStatusDialogMessage" (onClose)="closeReportStatusDialog()"
    [closeButtonText]="dialogTexts.REPORT_STATUS.CLOSE" [confirmButtonText]="reportStatusDialogButtonText"
    (onConfirm)="handleReportConfirm(reportId)">
</app-dialogue-box>
<app-dialogue-box [isDialogOpen]="isDeleteCommentDialogOpen" [title]="dialogTexts.DELETE_COMMENT.TITLE"
    [message]="dialogTexts.DELETE_COMMENT.MESSAGE" [confirmButtonText]="dialogTexts.DELETE_COMMENT.CONFIRM"
    (onClose)="closeDeleteCommentDialog()" (onConfirm)="deleteSectionComment()">
</app-dialogue-box>
<div class="report-container">
    <app-loader *ngIf="isLoading"></app-loader>
    <div *ngIf="sectionsData.length > 0 || !isLoading">
        <div class="report-top">
            <div class="report-header">
                <div class="report-summary-row">
                    <h2 class="report-id-h2">{{ labels.REPORT_SECTIONS.REPORT_ID }}{{ reportId }}</h2>
                    <span class="label report-header-text">{{ labels.REPORT_SECTIONS.STATUS }}</span>
                    <span class="report-header-text">{{ statusLabel }} &nbsp;&nbsp;</span>
                    <span class="label report-header-text">{{ labels.REPORT_SECTIONS.OVERALL_QUALITY }}</span>
                    <div class="section-score-badge-header">
                        <span class="overall-quality">{{ overallQuality }}%</span>
                    </div>
                    
                    <span class="label report-header-text">{{ labels.REPORT_SECTIONS.REPORT_TYPE }}</span>
                    <span class="report-header-text"> {{ reportDetails?.reportTypeName || '' }} </span>
                </div>

                <div class="ai-note-tablet">
                    {{ labels.REPORT_SECTIONS.NOTE }}
                </div>
                <p class="report-meta-row">
                    <span class="label report-header-text">{{ labels.REPORT_SECTIONS.CLIENT_NAME }}</span> <span
                        class="report-header-text">{{
                        clientName }} &nbsp;&nbsp;</span>
                    <span class="label report-header-text">{{ labels.REPORT_SECTIONS.CREATED_BY }}</span>
                    <span class="report-header-text">{{ createdBy }} &nbsp;&nbsp;</span>
                    <span class="label report-header-text">{{ labels.REPORT_SECTIONS.COMMENTS_COUNT }}</span>
                    <span class="overall-quality comments-count-badge-header">{{ commentsCount }} &nbsp;&nbsp;</span>
                  
                    
                </p>
            </div>
            <div class="report-data">
                <div class="custom-stepper">
                    <div class="step" [class.active]="isStepActive(1)" [class.done]="isStepDone(1)">
                        <div class="circle">
                            <mat-icon *ngIf="isStepDone(1); else showStep1" class="initial-center">check</mat-icon>
                            <ng-template #showStep1>
                                <div class="initial-center">1</div>
                            </ng-template>
                        </div>
                        <div class="label">{{ labels.COMMON.STEPS.INITIATE }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="step" [class.active]="isStepActive(2)" [class.done]="isStepDone(2)">
                        <div class="circle">
                            <mat-icon *ngIf="isStepDone(2); else showStep2" class="initial-center">check</mat-icon>
                            <ng-template #showStep2>
                                <div class="initial-center">2</div>
                            </ng-template>
                        </div>
                        <div class="label">{{ labels.COMMON.STEPS.ANALYZED }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="step" [class.active]="isStepActive(3)" [class.done]="isStepDone(3)">
                        <div class="circle">
                            <mat-icon *ngIf="isStepDone(3); else showStep3" class="initial-center">check</mat-icon>
                            <ng-template #showStep3>
                                <div class="initial-center">3</div>
                            </ng-template>
                        </div>
                        <div class="label">{{ labels.COMMON.STEPS.REVIEW }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="step" [class.active]="isStepActive(4)" [class.done]="isStepDone(4)">
                        <div class="circle">
                            <mat-icon *ngIf="isStepDone(4); else showApprovedStatus" class="initial-center">check</mat-icon>
                        </div>
                        <ng-template #showApprovedStatus>
                            <div class="initial-center">4</div>
                        </ng-template>
                        <div class="label">{{ labels.COMMON.STEPS.APPROVED }}</div>
                    </div>
                </div>
            </div>
        </div>


        <!-- mat-tree on new row -->
        <div class="report-layout">

            <!-- Tablet Controls -->
            <div class="tablet-controls">
                <button class="tablet-card" (click)="openTOC()" [class.active]="isTOCOverlayOpen"
                    aria-pressed="{{isTOCOverlayOpen}}">
                    <span class="button-text">{{ labels.REPORT_SECTIONS.TABLE_OF_CONTENTS }}</span>
                    <img src="/assets/icons/right-arrow-green.svg" />
                </button>

                <button class="tablet-card" (click)="openScores()" [class.active]="isScoresDialogOpen"
                    aria-pressed="{{isScoresDialogOpen}}" [attr.aria-label]="labels.REPORT_SECTIONS.AVERAGE_QUALITY_SCORE_ARIA">
                    <ng-container *ngIf="overAllQualityScore =='Good'">
                        <img src="/assets/icons/vector_green.svg" alt="Average Quality Score" />
                    </ng-container>
                    <ng-container *ngIf="overAllQualityScore =='Medium'">
                        <img src="/assets/icons/speed-vector.svg" alt="Average Quality Score" />
                    </ng-container>
                    <ng-container *ngIf="overAllQualityScore =='Low'">
                        <img src="/assets/icons/speed-vector.svg" alt="Average Quality Score" />
                    </ng-container>
                    <span class="button-text-score">
                        {{ labels.REPORT_SECTIONS.AVERAGE_QUALITY_SCORE }}
                        <strong class="score-value">{{ overAllQualityScore }}</strong>
                    </span>
                    <img src="/assets/icons/right-arrow-green.svg" />
                </button>
            </div>

            <div class="toc-panel">
                <app-report-outline [dataSource]="dataSource" [treeControl]="treeControl" [hasChild]="hasChild"
                    [isTreeCollapsed]="isTreeCollapsed" [scrollTo]="scrollTo.bind(this)">
                </app-report-outline>
            </div>

            <!-- Sections -->
            <div class="section-layout">
                <div class="section-scroll">
                    <div class="hearder-part">
                        <h2>{{reportName}}</h2>
                    </div>
                    <ng-container *ngFor="let section of sectionsData; let i = index">
                        <div class="section-check">
                            <mat-checkbox [checked]="isSectionChecked(section.id)"
                                (change)="onSectionCheckboxChange(section, $event.checked)"
                                [disabled]="section.status=='Approved' || section.status=='Initiated' || (isWriter && !isReviewer && section.status==='InReview') || !section.isEditable"></mat-checkbox>
                            <img *ngIf="status === 5" src="/assets/icons/lock.svg" alt="Locked" class="lock-icon" />
                            <div class="section-container" [id]="'sectionContainer-' + section.id">
                                <mat-card class="section-card" (click)="selectSection(section)"
                                    [class.selected-section]="selectedSection?.id === section.id && !section.isEditing">
                                    <!-- Section Header -->
                                    <div class="section-header">
                                        <ng-container *ngIf="!section.isEditing; else editHeader">
                                            <span class="section-title">
                                                {{ section.sectionNumber }} {{ section.name }}
                                            </span>
                                        </ng-container>

                                        <ng-template #editHeader>
                                            <input [(ngModel)]="section.sectionNumber"
                                                class="section-title-input-section-id-input"
                                                [attr.size]="(section.sectionNumber.length || 1) + 1" readonly />
                                            <input [(ngModel)]="section.name" class="section-title-input"
                                                placeholder="Section Title" />
                                        </ng-template>

                                        <div class="section-actions">
                                            @if(!isReviewer) {
                                            <button mat-icon-button *ngIf="!section.isEditing"
                                                (click)="editSection(section)"
                                                [disabled]="status === 4 || !section.isEditable || section.showBotProgress || (section.reviewerIds && section.reviewerIds.length > 0)">
                                                <img src="/assets/icons/edit.svg" alt="Close" />
                                            </button>
                                            <button mat-icon-button *ngIf="section.isEditing"
                                                (click)="cancelEdit(section)">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                            <button mat-icon-button *ngIf="section.isEditing"
                                                (click)="saveSection(section)"
                                                [disabled]="status === 4 || section.showBotProgress || (section.reviewerIds && section.reviewerIds.length > 0)">
                                                <img src="/assets/icons/save_section.svg" alt="Close" />
                                            </button>
                                            }
                                            <button mat-icon-button
                                                (click)="openNotesPopup(section.sectionNumber,section.id)"
                                                [disabled]="status === 4 || section.showBotProgress || !section.isEditable || (section.reviewerIds && section.reviewerIds.length > 0)">
                                                <img src="/assets/icons/note.svg" alt="Close" />
                                            </button>
                                            <span class="section-score-badge"
                                                *ngIf="section.sectionScore !== null && !section.isEditing">{{
                                                section.sectionScore }}%</span>
                                            <span class="section-status-badge"
                                                [ngClass]="{'in-review': section.status === 'InReview','rejected': section.status === 'Rejected' || section.status === 'Failed', 'ready-for-review': section.status !== 'InReview' && section.status !== 'Rejected'}">{{
                                                section.status}}</span>
                                            <div class="icon-overlay" *ngIf="section.status === 'Initiated'">
                                                <img src="/assets/icons/Vector.svg" alt="vector" class="vector-icon" />
                                                <img src="/assets/icons/robot.svg" alt="robot" class="robot-icon" />
                                            </div>

                                        </div>
                                    </div>

                                    <div class="section-content">
                                        <ng-container *ngIf="!section.isEditing; else editContent">
                                            <div [innerHTML]="section.content"></div>
                                        </ng-container>
                                        <ng-template #editContent>
                                            <div class="editor-wrapper">
                                                <angular-tiptap-editor class="custom-editor" [content]="section.content"
                                                    [showBubbleMenu]="false" [showImageBubbleMenu]="false"
                                                    [showToolbar]="true" [enableSlashCommands]="false"
                                                    (contentChange)="section.content = $event">
                                                </angular-tiptap-editor>
                                            </div>
                                        </ng-template>
                                    </div>

                                    <!-- Section Review Actions -->
                                    <div class="section-review-actions" *ngIf="selectedSection?.id === section.id && !section.isEditing && section.status !== 'Approved' && ((isWriter && !isReviewer) || (isReviewer && isCurrentUserReviewer(section)))">
                                        <details class="reviewers-dropdown" *ngIf="hasMappedReviewers(section.reviewerIds)">
                                            <summary>Reviewers ({{ getReviewerCount(section.reviewerIds) }})</summary>
                                            <ul class="reviewers-dropdown-list">
                                                <li *ngFor="let reviewerName of getReviewerNames(section.reviewerIds)">
                                                    {{ reviewerName }}
                                                </li>
                                            </ul>
                                        </details>
                                        <div class="section-review-buttons">
                                            @if(isWriter && !isReviewer) {
                                            <button type="button" class="aecom_btn--solid" [disabled]="section.status=='InReview'" (click)="openApprovalDialog()">
                                                {{ labels.REPORT_SECTIONS.BUTTON.SUBMIT_FOR_APPROVAL }}
                                            </button>
                                            }
                                            @if(isReviewer && isCurrentUserReviewer(section)) {
                                            <button type="button" class="aecom_btn" (click)="rejectSection()">
                                                {{ labels.REPORT_SECTIONS.BUTTON.SEND_FOR_REVISION }}
                                            </button>
                                            <button type="button" class="aecom_btn--solid" (click)="approveSection()">
                                                {{ labels.REPORT_SECTIONS.BUTTON.APPROVE_REPORT }}
                                            </button>
                                            }
                                        </div>
                                    </div>

                                </mat-card>
                            </div>
                        </div>


                    </ng-container>
                </div>

            </div>
        </div>

        <div class="page-action">
            <div class="ai-note">
                {{ labels.REPORT_SECTIONS.NOTE }}
            </div>
            <button type="button" class="action-buttons aecom_btn" (click)="redirectTohome()">{{ labels.COMMON.CLOSE
                }}</button>

            <button type="button" class="action-buttons aecom_btn--solid" (click)="checkSectionSelctionStatus()"
                [disabled]="IsPublishEnabled || sectionsData.length==0 || (status === 4 && isWriter && !isReviewer)">{{
                labels.REPORT_SECTIONS.BUTTON.AGENT_REWORK }}</button>
                 @if(isReviewer ) {
                    <button type="button" [disabled]="!IsPublishEnabled" (click)="publishReport()"
                    class="action-buttons aecom_btn--solid">{{labels.REPORT_SECTIONS.BUTTON.PUBLISH_REPORT }}
                </button>}
        </div>

    </div>
    <div class="notes-popup" *ngIf="notesStatus" [class.closing]="notesClosing">
        <div class="popup-header">
            <h1>{{ labels.REPORT_SECTIONS.COMMENT }} {{ reportId }}</h1>
            <mat-icon class="close-icon" (click)="closeNotesPopup()">close</mat-icon>
        </div>
        <div class="popup-body">

            <div class="add-notes">
                <div class="notes-box">
                    <span class="note-initials">
                        <div class="initial-center">{{ initials }}</div>
                    </span>
                    <textarea placeholder="{{ labels.REPORT_SECTIONS.ENTER_COMMENT }}" rows="7"
                        [(ngModel)]="newComment"></textarea>
                </div>

                <div class="notes-action">
                    <button class="add-note-button aecom_btn" (click)="clearComment()">{{
                        labels.REPORT_SECTIONS.COMMENT_CLEAR }}</button>
                    <button class="add-note-button aecom_btn--solid" (click)="postComment()">{{
                        labels.REPORT_SECTIONS.COMMENT_POST }}</button>
                </div>
            </div>

            <div class="notes-list">
                @for (note of notes; track note.commentId) {
                <div class="note-item">
                    <div class="note-header">
                        <div class="initial-name">
                            <span class="note-initials" [style.backgroundColor]="getUserColor(note.displayName)">
                                <div class="initial-center">{{ getInitials(note.displayName) }}</div>
                            </span>
                            <div class="note-info">
                                <p class="note-name">{{ note.displayName }} <button mat-icon-button color="warn"
                                        class="note-delete-btn"
                                        (click)="openDeleteDialogForComment(note.sectionId, note.commentId)"
                                        [disabled]="note.createdByEmail !== currentUserEmail">
                                        <img src="/assets/icons/delete.svg" alt="Close" />
                                    </button></p>
                                <p class="note-section"> {{ (note.sectionNumber && note.sectionNumber !== '0.0') ?
                                    note.sectionNumber : '' }}
                                </p>
                            </div>
                        </div>
                        <p class="note-timestamp">
                            {{ note.updatedDate | date:"dd-MM-yyyy '|' hh:mm a" }}
                        </p>

                    </div>
                    <p class="note-content">{{ note.userComment }}</p>
                </div>
                }
            </div>
        </div>
        <div class="popup-footer">
            <button class="add-note-button aecom_btn" (click)="closeNotesPopup()">{{ labels.COMMON.CLOSE }}</button>
        </div>
    </div>
</div>

<!-- Direct TOC Fullscreen Overlay (Tablet) -->
<div class="toc-backdrop-overlay" *ngIf="isTOCOverlayOpen" (click)="closeTOCOverlay()">
    <app-report-outline [dataSource]="dataSource" [treeControl]="treeControl" [hasChild]="hasChild"
        [isTreeCollapsed]="false" [scrollTo]="scrollTo.bind(this)">
    </app-report-outline>
</div>
<div class="toc-backdrop-overlay" *ngIf="isScoresDialogOpen" (click)="closeScores()">
    <app-report-scores [showScoreBoard]="showScoreBoard" [overAllQualityScore]="overAllQualityScore"
        [qualityScore]="qualityScore">
    </app-report-scores>
</div>


<div class="dialog-overlay" *ngIf="isApprovalDialogOpen || isApprovalDialogClosing"
    [ngClass]="{ 'closing': isApprovalDialogClosing }">
    <div class="site-manager-dialog-box">
        <div class="dialog-header">
            <h2 class="dialog-title">{{ labels.REPORT_SECTIONS.APPROVAL_DIALOG_TITLE }}</h2>
            <button class="close-btn" aria-label="Close"
                (click)="closeApprovalDialog(); showSuggestions = false">&times;</button>
        </div>
        <br>
        <div class="dialog-content">
            <div class="site-manager-select">
                <label for="selectSection">{{ labels.REPORT_SECTIONS.SElECT_SITE_MANAGER }}</label>
                <div class="search-container">
                    <input type="text" class="search-input" [placeholder]="labels.REPORT_SECTIONS.SEARCH_REVIEWERS_PLACEHOLDER"
                        [(ngModel)]="searchText" (input)="onSearch()" (focus)="showSuggestions = true; onSearch()"
                        (click)="showSuggestions = true; onSearch()" (blur)="onSearchBlur()" autocomplete="off" />

                    <img class="search-icon" src="/assets/icons/search.svg" alt="Search" />
                    <!-- Suggestions -->
                    <div class="suggestions-panel" *ngIf="showSuggestions && filteredReviewers.length">
                        <div class="suggestions-scroll">
                            <div class="suggestion-item" *ngFor="let reviewer of filteredReviewers"
                                (mousedown)="$event.preventDefault(); selectReviewer(reviewer)">
                                <div class="name">{{ reviewer.displayName }}</div>
                                <div class="email">{{ reviewer.email }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Selected reviewers chips -->
                <div class="selected-reviewers-list" *ngIf="selectedReviewers.length > 0">
                    <div class="reviewer-chip" *ngFor="let reviewer of selectedReviewers">
                        <span class="selected-name">{{ reviewer.displayName }}</span>
                        <span class="selected-email">{{ reviewer.email }}</span>
                        <mat-icon class="remove-reviewer" (click)="removeReviewer(reviewer)">close</mat-icon>
                    </div>
                </div>
            </div>

            <div class="dialog-actions">
                <button class="add-note-button aecom_btn" (click)="closeApprovalDialog(); showSuggestions = false">{{
                    labels.COMMON.CLOSE}}</button>
                <button type="button" class="action-buttons aecom_btn--solid" (click)="addReviewerForApproval()"
                    [disabled]="selectedReviewers.length === 0">{{
                    labels.REPORT_SECTIONS.BUTTON.ASSIGN_FOR_APPROVAl }} </button>
            </div>
        </div>

    </div>
</div>

<!-- Approve/Reject Section Feedback Dialog -->
<div class="dialog-overlay" *ngIf="isApproveSectionDialogOpen || isApproveSectionDialogClosing"
    [ngClass]="{ 'closing': isApproveSectionDialogClosing }">
    <div class="site-manager-dialog-box">
        <div class="dialog-header">
            <h2 class="dialog-title">{{ feedbackDialogAction === 'approve' ? labels.REPORT_SECTIONS.APPROVE_SECTION_TITLE : labels.REPORT_SECTIONS.BUTTON.SEND_FOR_REVISION }}
            </h2>
            <button class="close-btn" aria-label="Close" (click)="closeApproveSectionDialog()">&times;</button>
        </div>
        <br>
        <div class="dialog-content">
            <div class="approve-feedback-section">
                <label for="approveFeedback">{{ labels.REPORT_SECTIONS.FEEDBACK_OPTIONAL }}</label>
                <textarea id="approveFeedback" class="feedback-textarea" rows="5"
                    [placeholder]="labels.REPORT_SECTIONS.FEEDBACK_PLACEHOLDER" [(ngModel)]="approveFeedback"
                    maxlength="1000"></textarea>
                <span class="char-count">{{ approveFeedback.length }}/1000</span>
            </div>

            <div class="dialog-actions">
                <button class="add-note-button aecom_btn" (click)="closeApproveSectionDialog()">{{
                    labels.COMMON.CLOSE }}</button>
                <button type="button" class="action-buttons aecom_btn--solid"
                    (click)="confirmApproveOrRejectSection()">{{ feedbackDialogAction === 'approve' ? labels.REPORT_SECTIONS.BUTTON.APPROVE_REPORT : labels.REPORT_SECTIONS.BUTTON.SEND_FOR_REVISION }}</button>
            </div>
        </div>
    </div>
</div>